import { FC } from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';
import { get, isEmpty } from 'lodash';
import { useGetApplication, useGetPayloadWithProvided } from '~/controllers/wizard';
import { getStagePayload } from '~/utils/getStagePayload';
import { KsaShareholders } from '~/types/ksa/KsaShareholders';
import { isCurrentUserByEmail } from '~/utils/getDecodedJwt';
import { KsaPerson } from '~/types/ksa/KsaPerson';
import { WithCurrentUserTag } from '~/components/CurrentUser';
import ShareholdersSoleProprietor from './components/ShareholdersSoleProprietor';
import ShareholdersMultiple from './components/ShareholdersMultiple';
import { getIndividualsFormName } from './components/individuals/IndividualEdit';

const Shareholders: FC = () => {
  const applicationQuery = useGetApplication();
  const stagePayload = getStagePayload.wizard(applicationQuery.data);
  const payload = useGetPayloadWithProvided();

  const activeStep = stagePayload?.activeStep;
  const individualShareholdersCount = payload?.shareholders?.individuals?.length;
  const legalEntities = (payload?.shareholders as KsaShareholders)?.legalEntities;

  // Checks if current shareholder is a current user
  const individualFromProvided: KsaPerson | undefined = get(
    payload?.provided,
    getIndividualsFormName(0)
  );
  const individualEmail = individualFromProvided?.personalData?.email;
  const isCurrent = isCurrentUserByEmail(individualEmail);
  return (
    <Container>
      <Typography.Title>
        <WithCurrentUserTag showLabel={isCurrent}>{activeStep?.stepName}</WithCurrentUserTag>
      </Typography.Title>
      {individualShareholdersCount === 1 && isEmpty(legalEntities) ? (
        <ShareholdersSoleProprietor />
      ) : (
        <ShareholdersMultiple />
      )}
    </Container>
  );
};

export const stepName = 'shareholders';

const Container = styled.div`
  h4 {
    margin-bottom: 24px;
  }
`;

export default Shareholders;
